import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fa2ea7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "complete" }
const _hoisted_2 = { class: "display_complete" }
const _hoisted_3 = { class: "card-body text-center display_box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-title text-primary mb-3" }, "Application Complete!", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("small", null, [
          _createVNode(_component_router_link, { to: "/innovator/application" }, {
            default: _withCtx(() => [
              _createTextVNode("Click to see application progress here")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}